import { writable } from "svelte/store";
import { cTypes } from "./cs";

const LS_KEY = "ns-cookie-consent";
const TTL_REJECT = 1000 * 60 * 60 * 24 * 7; // Save a reject for a week

export const cConsentStatus = {
    ACCEPTED: 1,
    REJECTED: 0,
    UNKNOWN: null,
};

function getPersistedStatus() {
    let consentData = localStorage.getItem(LS_KEY);
    if (consentData === null) {
        return createDataStructure([], [], 0);
    }
    try {
        const data = JSON.parse(consentData);

        // Might we ask again if we have a rejection?
        const askAgain = new Date().getTime() > data.storeDate + TTL_REJECT;
        // Check if we should as for consent (i.e. we have an old rejection)
        Object.values(cTypes).forEach((which) => {
            // New cookie type
            if (typeof data.types[which.id] === "undefined") {
                data.types[which.id] = cConsentStatus.UNKNOWN;
            }
            if (data.types[which.id] === cConsentStatus.REJECTED && askAgain) {
                data.types[which.id] = cConsentStatus.UNKNOWN;
            }
        });
        const types = Object.keys(data.types);
        return createDataStructure(
            types.filter((type) => data.types[type] === cConsentStatus.ACCEPTED),
            types.filter((type) => data.types[type] === cConsentStatus.REJECTED),
            data.storeDate,
        );
    } catch (e) {
        return createDataStructure([], [], 0);
    }
}

function persist(data) {
    localStorage.setItem(LS_KEY, JSON.stringify(data));
}

function createDataStructure(accept = [], reject = [], date = new Date().getTime()) {
    const consentData = {
        storeDate: date,
        types: {},
    };
    Object.values(cTypes).forEach((which) => {
        consentData.types[which.id] = accept.includes(which.id)
            ? cConsentStatus.ACCEPTED
            : reject.includes(which.id)
            ? cConsentStatus.REJECTED
            : cConsentStatus.UNKNOWN;
    });
    return setHasUnknown(consentData);
}

function setHasUnknown(data) {
    const res = Object.values(data.types).some((val) => val === cConsentStatus.UNKNOWN);
    return {
        ...data,
        hasUnknown: res,
    };
}

function createCConsentStore() {
    const store = writable(createDataStructure([], [], 0));
    const customStore = {
        acceptAll: () => {
            const obj = createDataStructure(
                Object.values(cTypes).map((t) => t.id),
                [],
            );
            store.set(obj);
            persist(obj);
        },
        setStatus: (acc = [], rej = []) => {
            store.set(createDataStructure(acc, rej));
            persist(createDataStructure(acc, rej));
        },
        readSync: () => {
            const status = getPersistedStatus();
            store.set(status);
        },
        subscribe: store.subscribe,
    };

    return customStore;
}

const cConsentStore = createCConsentStore();

export { cConsentStore };
